import React, { Component } from "react";
import styled from "styled-components";

import Modal from "../Modal";
import * as uri from "../../config/uri";
import RaisedButton from "material-ui/RaisedButton";
import { HeaderDiv, SmallTextDiv } from "../../modals";
import { ACCENT_COLOR } from "../../config/colors";

const styles = {
  closeIcon: {
    position: "absolute",
    top: 0,
    right: "0",
    margin: "8px 5px 0 0"
  },
  labelStyle: { fontWeight: 700 }
};

class GenericModal extends Component {
  modalStyle = { border: "3px solid " + ACCENT_COLOR };
  handleCloseClick = () => {
    const { hideModal, go, stay } = this.props;
    hideModal();
    if (typeof this.props.afterClose === "function"){
      this.props.afterClose();
    }


    if (stay) return;
    go(uri.rootPageUri);
  };

  render() {
    return (
      <Modal
        style={this.modalStyle}
        overlayTop={0}
        paddingTop={100}
        closeOnOutsideClick={true}
        isOpened={true}
        onClose={this.onCloseRequest}
      >
        <ModalWrapperDiv>
          <HeaderDiv color={`#616161`}>{this.props.text}</HeaderDiv>
          <SmallTextDiv color={`#616161`}>{this.props.smallText}</SmallTextDiv>
          <ButtonsWrapperDiv>
            <RaisedButton
              onClick={this.handleCloseClick}
              backgroundColor={`#` + this.props.secondaryColor}
              labelColor="#FFF"
              label="OK"
              labelStyle={styles.labelStyle}
            />
          </ButtonsWrapperDiv>
        </ModalWrapperDiv>
      </Modal>
    );
  }
}

export default GenericModal;

const ModalWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  height: 100%;
  font-family: "Futura-Bold", sans-serif;
`;

const ButtonsWrapperDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
`;



// WEBPACK FOOTER //
// ./src/components/GenericModal/GenericModal.jsx